function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 8 */
import { Configuration } from "./Configuration";
import { ArgumentException } from "./Exceptions";
/**
 * Variable that contains promise indicating that google api was initialized
 */

var _googlePlacesInitPromise = null;
/**
 * Decodes "place" object received from google api into a simpler JSON object
 * @param {object} place Google Place selection result
 */

var _decodeGooglePlacesData = function _decodeGooglePlacesData(place) {
  var result = null;

  if (!!place && !!place.address_components && !!place.address_components.length) {
    var components = place.address_components;
    result = {};

    for (var idx in components) {
      var component = components[idx];

      if (!!component) {
        var value = component.long_name;
        var shortValue = component.short_name;

        if (!!value && !!component.types && !!component.types.length) {
          var type = component.types[0];

          switch (type) {
            case "street_number":
              result.address = result.address || [];
              result.address[0] = value;
              break;

            case "route":
              result.address = result.address || [];
              result.address[1] = value;
              break;

            case "locality":
              result.city = value;
              break;

            case "administrative_area_level_1":
              result.state = shortValue || value;
              break;

            case "country":
              result.country = value;
              break;

            case "postal_code":
              result.postalCode = value;
              break;
          }
        }
      }
    }

    result.addressLine1 = !!result.address ? result.address.join(" ") : "";
  }

  return result;
};
/**
 * Method is responsible for injecting Google Places Api script into the page
 * @param {HTMLElement} parentContainer Element into which script tag will be injected
 * @param {string} apiKey Google API key
 */


var _loadGooglePlacesScript = function _loadGooglePlacesScript(parentContainer, apiKey) {
  if (!parentContainer) {
    throw new ArgumentException("parentContainer");
  }

  if (!apiKey) {
    throw new ArgumentException("apiKey");
  }

  return new Promise(function (resolve, reject) {
    window.initGoogleAutoComplete = function () {
      resolve();
    };

    window.gm_authFailure = function (data) {
      console.log("Gogle Places Init failed");
      console.log(data);
      reject();
    };

    var script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(apiKey, "&libraries=places&callback=initGoogleAutoComplete");

    script.onerror = function (err) {
      console.log("Gogle Places Init error");
      console.log(err);
      reject();
    };

    script.onabort = function (err) {
      console.log("Gogle Places Init abort");
      console.log(err);
      reject();
    };

    parentContainer.appendChild(script);
  });
};
/**
 * Creates a framework to add Google Places API address autocomplete to a textbox
 */


export var AddressAutoComplete = /*#__PURE__*/function () {
  /**
   * Class constructor. Gets API key, initializes Google Places JS API
   * @param {HTMLElement} parentContainer Parent container into which Google API script will be injected
   */
  function AddressAutoComplete(parentContainer) {
    _classCallCheck(this, AddressAutoComplete);

    if (!parentContainer) {
      throw new ArgumentException("parentContainer");
    }

    var config = new Configuration();

    if (_googlePlacesInitPromise == null) {
      config.GetConfigurationSetting("GoogleMapsAPIKey").then(function (gApiKey) {
        if (!!gApiKey) {
          _googlePlacesInitPromise = _loadGooglePlacesScript(parentContainer, gApiKey);
        }
      });
    }
  }
  /**
   * Attaches autocomplete functionality to the given textbox, triggers callback on address select
   * @param {HTMLElement} textBoxElement Element (textbox) to which Autocomplete functionality will be attached
   * @param {Function} addressSelectedCallback OnSelect callback
   */


  _createClass(AddressAutoComplete, [{
    key: "attach",
    value: function attach(textBoxElement, addressSelectedCallback) {
      if (!textBoxElement) {
        throw new ArgumentException("textBoxElement");
      }

      if (!addressSelectedCallback) {
        throw new ArgumentException("addressSelectedCallback");
      }

      if (_googlePlacesInitPromise != null) {
        _googlePlacesInitPromise.then(function () {
          var googleAutoComplete = new google.maps.places.Autocomplete(textBoxElement, {
            types: ['geocode']
          });
          googleAutoComplete.setFields(['address_component']);
          googleAutoComplete.addListener('place_changed', function () {
            var place = googleAutoComplete.getPlace();

            var address = _decodeGooglePlacesData(place);

            addressSelectedCallback(address);
          });
        }, function () {
          console.log("Unable to attach address autocomplete. Google Places API is not initialized!");
        });
      } else {
        console.log("Ignored. Google Places API is not initialized.");
      }
    }
  }]);

  return AddressAutoComplete;
}();